import { ActionType } from 'typesafe-actions'
import {
  ADD_PERSON_REQUESTED,
  ADD_PERSON_COMPLETED,
  ADD_PERSON_FAILED,
  SET_ERROR_MSG_TYPE,
  PROVIDERS_REQUESTED,
  PROVIDERS_COMPLETED,
  PROVIDERS_FAILED,
} from 'actions/walkUpReg-actions'

import * as actions from 'actions/walkUpReg-actions'
import { MessageTypes } from 'constants/message-screens'
import { Provider } from 'types/global'

type WalkUpRegAction = ActionType<typeof actions>

export type State = Readonly<{
  registrationToken: string
  alreadyItfCustomer: boolean
  alreadyRegisteredForService: boolean
  isAddingPerson: boolean
  errorAddingPerson: Error | null
  errorMsgType: MessageTypes
  errorLoadingProviders: Error | null
  loadingProviders: boolean
  providers: Provider[] | null
}>

const initialState: State = {
  registrationToken: '',
  alreadyItfCustomer: false,
  alreadyRegisteredForService: false,
  isAddingPerson: false,
  errorAddingPerson: null,
  errorMsgType: MessageTypes.DEFAULT,
  errorLoadingProviders: null,
  loadingProviders: false,
  providers: null,
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: WalkUpRegAction): State {
  switch (action.type) {
    case ADD_PERSON_REQUESTED:
      return { ...state, isAddingPerson: true, errorAddingPerson: null }
    case ADD_PERSON_COMPLETED:
      return { ...state, ...action.payload, isAddingPerson: false, errorAddingPerson: null }
    case ADD_PERSON_FAILED:
      return { ...state, errorAddingPerson: action.payload, isAddingPerson: false }
    case SET_ERROR_MSG_TYPE:
      return { ...state, errorMsgType: action.payload }
    case PROVIDERS_REQUESTED:
      return { ...state, errorLoadingProviders: null, loadingProviders: true }
    case PROVIDERS_COMPLETED:
      return { ...state, providers: action.payload, loadingProviders: false, errorLoadingProviders: null }
    case PROVIDERS_FAILED:
      return { ...state, errorLoadingProviders: action.payload, loadingProviders: false }
    default:
      return state
  }
}
